import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/@babel/runtime/helpers/esm/createClass";

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, privateMap, value) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to set private field on non-instance");
  }

  privateMap.set(receiver, value);
  return value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, privateMap) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return privateMap.get(receiver);
};

var _metadata;

import { resolveManifest, resolveArtifact } from '../utils/metadata';

var App =
/*#__PURE__*/
function () {
  function App(data, metadata, organization) {
    _classCallCheck(this, App);

    _metadata.set(this, void 0);

    __classPrivateFieldSet(this, _metadata, metadata);

    this.address = data.address;
    this.appId = data.appId;
    this.codeAddress = data.codeAddress;
    this.contentUri = data.contentUri;
    this.isForwarder = data.isForwarder;
    this.isUpgradeable = data.isUpgradeable;
    this.kernelAddress = data.kernelAddress;
    this.name = data.name;
    this.organization = organization;
    this.registry = data.registry;
    this.registryAddress = data.registryAddress;
    this.repoAddress = data.repoAddress;
    this.version = data.version;
  }

  _createClass(App, [{
    key: "orgConnector",
    value: function orgConnector() {
      return this.organization.connection.orgConnector;
    }
  }, {
    key: "repo",
    value: function () {
      var _repo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.orgConnector().repoForApp(this.organization, this.address));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function repo() {
        return _repo.apply(this, arguments);
      }

      return repo;
    }()
  }, {
    key: "roles",
    value: function () {
      var _roles = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.orgConnector().rolesForAddress(this.organization, this.address));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function roles() {
        return _roles.apply(this, arguments);
      }

      return roles;
    }()
  }, {
    key: "artifact",
    get: function get() {
      return __classPrivateFieldGet(this, _metadata)[0];
    }
  }, {
    key: "manifest",
    get: function get() {
      return __classPrivateFieldGet(this, _metadata)[1];
    }
  }, {
    key: "abi",
    get: function get() {
      return this.artifact.abi;
    }
  }, {
    key: "intents",
    get: function get() {
      return this.artifact.functions;
    }
  }, {
    key: "deprecatedIntents",
    get: function get() {
      return this.artifact.deprecatedFunctions;
    }
  }, {
    key: "appName",
    get: function get() {
      return this.artifact.appName;
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(data, organization) {
        var artifact, manifest, metadata;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return resolveArtifact(data);

              case 2:
                artifact = _context3.sent;
                _context3.next = 5;
                return resolveManifest(data);

              case 5:
                manifest = _context3.sent;
                metadata = [artifact, manifest];
                return _context3.abrupt("return", new App(data, metadata, organization));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function create(_x, _x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return App;
}();

export { App as default };
_metadata = new WeakMap();